"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDropzone = _interopRequireWildcard(require("react-dropzone"));
var _Button = _interopRequireDefault(require("../button/Button"));
var _excluded = ["label", "accept", "multiple", "maxSize", "displayMode", "onPick", "className", "children"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FilePicker = function FilePicker(props) {
  var label = props.label,
    accept = props.accept,
    multiple = props.multiple,
    maxSize = props.maxSize,
    displayMode = props.displayMode,
    onPick = props.onPick,
    className = props.className,
    children = props.children,
    remainigProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var dropzoneRef = (0, _react.useRef)();
  var isButton = displayMode === 'button';
  var isDropzone = displayMode === 'dropzone';
  var isFull = displayMode === 'full';
  var showButton = isButton || isFull;
  var showDropzone = isDropzone || isFull;
  var handleDrop = (0, _react.useCallback)(function (acceptedFiles, rejectedFiles) {
    var hasImagesType = accept && Object.keys(accept).some(function (mimeType) {
      return mimeType.startsWith('image');
    });
    var files = hasImagesType ? acceptedFiles.map(function (file) {
      return Object.assign(file, {
        preview: URL.createObjectURL(file)
      });
    }) : acceptedFiles;
    onPick(files, rejectedFiles);
  }, [onPick, accept]);
  var onOpenClick = function onOpenClick() {
    return dropzoneRef.current.open();
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "FilePicker"
  }, showButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onOpenClick,
    className: className
  }, label), /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], (0, _extends2["default"])({}, remainigProps, {
    onDrop: handleDrop,
    accept: accept,
    multiple: multiple,
    maxSize: maxSize,
    ref: dropzoneRef
  }), function (_ref) {
    var getRootProps = _ref.getRootProps,
      getInputProps = _ref.getInputProps,
      isDragActive = _ref.isDragActive;
    return /*#__PURE__*/_react["default"].createElement("div", getRootProps(), /*#__PURE__*/_react["default"].createElement("input", getInputProps()), showDropzone && children && children({
      isDragActive: isDragActive
    }));
  }));
};
FilePicker.DISPLAY_MODE_BUTTON = 'button';
FilePicker.DISPLAY_MODE_DROPZONE = 'dropzone';
FilePicker.DISPLAY_MODE_FULL = 'full';
FilePicker.defaultProps = {
  displayMode: 'button',
  multiple: true,
  label: 'Select Files',
  onPick: function onPick() {},
  className: ''
};
FilePicker.propTypes = {
  displayMode: _propTypes["default"].string /* Display mode: 'dropzone' / 'button' / 'full' */,
  multiple: _propTypes["default"].bool /* Allow multiple file selections or not */,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]) /* Text to display on Button */,
  accept: _propTypes["default"].object /* Object list of accepted Mime Types as keys and file extensions array as value */,
  maxSize: _propTypes["default"].number /* Maximum File Size */,
  onPick: _propTypes["default"].func /* Pick callback */,
  className: _propTypes["default"].string /* Custom className for the displayed component (dropzone/button) */,
  children: _propTypes["default"].any
};
var _default = FilePicker;
exports["default"] = _default;